import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APISettoreAttivita {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

    }

    return result + nome_metodo;


  }

  // async saveSettoreAttivita(settore_attivita, user, id) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("val_id", id);

  //   for (var key in settore_attivita) {
  //     formData.append(key, settore_attivita[key]);
  //   }

  //   return axios.post(this.getUrlDomain("EmtAgilaSaveSettAttApi"), formData, { 'Content-Type': 'multipart/form-data' });

  // }



  async saveSettoreAttivita(settore_attivita, user, id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    for (var key in settore_attivita) {
      formData.append(key, settore_attivita[key]);
    }

    return axios.post(this.getUrlDomain("goSaveSettoreAttivita"), formData, { 'Content-Type': 'multipart/form-data' });

  }




  // async editSettoreAttivita(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("id", id);


  //   return axios.post(this.getUrlDomain("EmtAgilaEditSettAttApi"), formData, { 'Content-Type': 'multipart/form-data' });

  // }


  async editSettoreAttivita(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("id", id);


    return axios.post(this.getUrlDomain("goEditSettoreAttivita"), formData, { 'Content-Type': 'multipart/form-data' });

  }





  // async deleteSettoreAttivita(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("val_id", id);


  //   return axios.post(this.getUrlDomain("EmtAgilaDeleteSettAttApi"), formData, { 'Content-Type': 'multipart/form-data' });

  // }


  async deleteSettoreAttivita(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);


    return axios.post(this.getUrlDomain("goDeleteSettoreAttivita"), formData, { 'Content-Type': 'multipart/form-data' });

  }



}

export default new APISettoreAttivita({
  url: "https://services.ebadge.it/public/api/"
})
